const mutationTypes = {
  SET_LICENSE: 'setLicense',
  IS_II_PROJECT: 'isIIProject',
  IS_AVG_PROJECT: 'IS_AVG_PROJECT',
  IS_ONE_PROJECT: 'IS_ONE_PROJECT',
  IS_DIGITAL35_PROJECT: 'IS_DIGITAL35_PROJECT',
  IS_EKAV_PROJECT: 'IS_EKAV_PROJECT',
  IS_TICKET_PROJECT: 'IS_TICKET_PROJECT',
  IS_GMVA_PROJECT: 'IS_GMVA_PROJECT',
};

const state = {
  license: null,
  isIIProject: null,
  isReportModule: null,
  isRPTradeModule: null,
  isAVGProject: null,
  isONEProject: null,
  isDIGITAL35Project: null,
  isEKAVProject: null,
  isTicketProject: null,
  isGMVAProject: null,
};

const mutations = {
  [mutationTypes.SET_LICENSE]: (state, license) => {
    state.license = license;
  },
  [mutationTypes.IS_AVG_PROJECT]: (state, value) => {
    state.isAVGProject = value;
  },
  [mutationTypes.IS_ONE_PROJECT]: (state, value) => {
    state.isONEProject = value;
  },
  [mutationTypes.IS_DIGITAL35_PROJECT]: (state, value) => {
    state.isDIGITAL35Project = value;
  },
  [mutationTypes.IS_EKAV_PROJECT]: (state, value) => {
    state.isEKAVProject = value;
  },
  [mutationTypes.IS_II_PROJECT]: (state, value) => {
    const { isIIProject, isReportModule, isRPTradeModule } = value;
    state.isIIProject = isIIProject;
    state.isReportModule = isReportModule;
    state.isRPTradeModule = isRPTradeModule;
  },
  [mutationTypes.IS_TICKET_PROJECT]: (state, value) => {
    state.isTicketProject = value;
  },
  [mutationTypes.IS_GMVA_PROJECT]: (state, value) => {
    state.isGMVAProject = value;
  }
};

const actions = {
  setLicense: ({ commit }, license) => {
    commit(mutationTypes.SET_LICENSE, license);
  },
  isIIProject: ({ commit }, value) => {
    commit(mutationTypes.IS_II_PROJECT, value);
  },
  isAVGProject: ({ commit }, value) => {
    commit(mutationTypes.IS_AVG_PROJECT, value);
  },
  isONEProject: ({ commit }, value) => {
    commit(mutationTypes.IS_ONE_PROJECT, value);
  },
  isDIGITAL35Project: ({ commit }, value) => {
    commit(mutationTypes.IS_DIGITAL35_PROJECT, value);
  },
  isEKAVProject: ({ commit }, value) => {
    commit(mutationTypes.IS_EKAV_PROJECT, value);
  },
  isTicketProject: ({ commit }, value) => {
    commit(mutationTypes.IS_TICKET_PROJECT, value);
  },
  isGMVAProject: ({ commit }, value) => {
    commit(mutationTypes.IS_GMVA_PROJECT, value);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
